import {InjectionToken} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export const AUTH_TOKEN = new InjectionToken<BehaviorSubject<string | undefined>>('AUTH_TOKEN');
